import script from "./BaseSurface.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseSurface.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__